import { render, staticRenderFns } from "./DocsCanvas.vue?vue&type=template&id=82501072&"
import script from "./DocsCanvas.vue?vue&type=script&lang=js&"
export * from "./DocsCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports